import React from "react";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import { Badge } from "components/common/Badge";
import { SectionRule } from "components/common/SectionRule";
import { OrgMark } from "@/components/main/organizations/OrgMark";
import { useOrgContextStore } from "@/components/main/stores/orgContextStore";
import type { Org } from "@/lib/api/organizations";

const roleLabel = (org: Org): string => {
  // A personal org is named "Personal" until its owner renames it.
  if (org.is_personal)
    return org.name.toLowerCase() === "personal" ? "" : "Personal";
  if (org.role === "owner") return "Owner";
  if (org.role === "org_admin") return "Admin";
  return org.role ? "Member" : "";
};

export const OrgList: React.FC<{ onOpenOrg: (org: Org) => void }> = ({
  onOpenOrg,
}) => {
  const orgs = useOrgContextStore((s) => s.orgs);
  if (orgs.length === 0) return null;
  const sorted = [...orgs].sort(
    (a, b) =>
      Number(b.is_personal) - Number(a.is_personal) ||
      a.name.localeCompare(b.name),
  );

  return (
    <section aria-label="Organizations">
      <SectionRule label="Organizations" count={sorted.length} />
      <div className="flex flex-col">
        {sorted.map((org) => (
          <button
            key={org.org_id}
            type="button"
            className="settings-row"
            aria-label={`Open settings for ${org.name}`}
            onClick={() => onOpenOrg(org)}
          >
            <OrgMark org={org} size="sm" />
            <span className="min-w-0 flex-1 truncate text-left text-fg-regular">
              {org.name}
            </span>
            <span className="text-fg-muted-regular-small">
              {roleLabel(org)}
            </span>
            <span className="settings-org-plan">
              {org.plan_name && <Badge label={org.plan_name} />}
            </span>
            <NorthEastIcon className="settings-row-go" sx={{ fontSize: 12 }} />
          </button>
        ))}
      </div>
    </section>
  );
};
